export default __webpack_public_path__ + "static/gearsOfWar-full-66a071c5bcb9961e9aac714937428725.svg";